var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEventosOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.564,
    height: 20.405,
    viewBox: "0 0 18.564 20.405",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.5 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.34,5H19.224a2.844,2.844,0,0,1,2.84,2.84V20.724a2.844,2.844,0,0,1-2.84,2.84H6.34a2.844,2.844,0,0,1-2.84-2.84V7.84A2.844,2.844,0,0,1,6.34,5ZM19.224,21.564a.841.841,0,0,0,.84-.84V7.84a.841.841,0,0,0-.84-.84H6.34a.841.841,0,0,0-.84.84V20.724a.841.841,0,0,0,.84.84Z",
    transform: "translate(0 -1.16)",
    fill: "#c2c4d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,7.681a1,1,0,0,1-1-1V3a1,1,0,0,1,2,0V6.681A1,1,0,0,1,24,7.681Z",
    transform: "translate(-7.537)",
    fill: "#c2c4d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,7.681a1,1,0,0,1-1-1V3a1,1,0,0,1,2,0V6.681A1,1,0,0,1,12,7.681Z",
    transform: "translate(-2.899)",
    fill: "#c2c4d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.064,16H4.5a1,1,0,0,1,0-2H21.064a1,1,0,0,1,0,2Z",
    transform: "translate(0 -4.638)",
    fill: "#c2c4d4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventosOff);
export default __webpack_public_path__ + "static/media/Eventos-Off.6068db3482cb03d5245c39a4c68354ef.svg";
export { ForwardRef as ReactComponent };